<template>
    <div class="warn_box">
        <!-- 实时告警数据 -->
       <template v-if="!isHistory"> 
            <div class="warnWeather_box wh100" v-if="warnWeatherList">
                <div>
                    <span :style="warnColor(this.warnWeatherList)" class="iconfont icon-gaojing1"></span>
                    <div>
                    <p :style="warnColor(this.warnWeatherList)">{{ warnLevel(this.warnWeatherList) }}</p>
                    <p>
                        <span>{{ warnWeatherList.typeName }}预警</span>
                        <span class="active">预警中</span>
                    </p>
                    </div>
                </div>
                <div>
                    <span>发布时间：</span>
                    <span>{{ handleTime(warnWeatherList.pubTime) }}</span>
                </div>
                <div class="boxsubBg">
                    <span class="iconfont icon-gaojing1" :style="warnColor(this.warnWeatherList)"></span>
                    <div style="width: 100%; overflow: hidden">
                    <p class="sinleline">{{ warnWeatherList.title }}</p>
                    <!-- sinleline -->
                    <p class="textAnimate">{{ warnWeatherList.text }}</p>
                    </div>
                </div>
            </div>
            <template v-else>
                <el-empty :image-size="80" :image="noDataUrl" description="暂无气象预警信息"></el-empty>
            </template>
            <div class="history_but baseColor" @click="isHistory = true"><span class="cp">历史预警>></span></div>
       </template> 
       <template v-else>
        <div class="history_box wh100">
            <div class="back_but">
                <span class="cp baseColor font-12" @click="isHistory = false"> &lt;&lt;返回 </span>
            </div> 
            <div class="history_list scrollbarMiniGary" v-if="warnHistoryList.length > 0">
                <div class="history_item boxsubBg" v-for="item in warnHistoryList" :key="item.id">
                    <span class="iconfont icon-gaojing1 icon" :style="warnColor(item)"></span>
                    <div class="history_item_content">
                        <div>
                            <span class="font-14">{{ item.title }}</span>
                            <!-- <span class="font-12">{{ item.pubTime }}</span> -->
                        </div>
                        <div class="font-12">{{ item.text }}</div>
                        <div class="font-12 tr">{{ handleTime(item.pubTime) }}</div>
                    </div>
                </div>
            </div>
            <template v-else>
                <div class="notData">
                    <el-empty :image-size="80" :image="noDataUrl" description="暂无历史气象预警信息"></el-empty>
                </div>
                
            </template>
        </div>
       </template>
    </div>
</template>

<script>
    import config from "@/config";
    export default {
        props: {
            warnWeatherList: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                noDataUrl: require("@/assets/imgs/noData/no_data2.png"),
                isHistory: false,
                warnHistoryList: []
            }
        },
        created(){
            this.getWarnHistoryList();
        },
        methods: {
            async getWarnHistoryList(){
              
                let res = await this.$api.EntWeatherWarningPageList({ pageIndex: 1, pageSize: 3 });
                this.warnHistoryList = res ?.list || [];
            },
            handleTime(time){
                return this.$day(time).format("YYYY-MM-DD HH:mm:ss");
            },
            warnLevel(item){
                const levelInfo = {
                    Black: "黑色",
                    Red: "红色",
                    Yellow: "黄色",
                    Blue: "蓝色",
                    Green: "绿色",
                    White: "白色",
                    Orange: "橙色",
                };
                return levelInfo[item.severityColor] || "";
            },
            warnColor(item){
                
                let color = config.warnWeatherColor[item.severityColor] || "#fff";
                return {
                    color,
                };
             
            }
        }
    }
</script>

<style lang="scss" scoped>
.warn_box {
    width: 100%;
    height: 100%;
    position: relative;
    .warnWeather_box {
        padding: 8px;
        box-sizing: border-box;
        & > div:first-child {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0px 0 8px 0;
            & > span {
            font-size: 50px;
            margin-right: 18px;
            }
            & > div {
            font-size: 22px;
            & > p {
            }
            & > p:last-child {
                font-size: 18px;
                margin-top: 4px;
                & > span:last-child {
                display: inline-block;
                margin-left: 12px;
                font-size: 14px;
                padding: 3px 16px;
                border-radius: 18px;
                }
            }
            }
        }
        & > div:nth-child(2) {
            font-size: 14px;
            text-align: center;
        }
        & > div:last-child {
            width: 100%;
            margin-top: 10px;
            height: 56px;
            padding: 0 10px;
            border-radius: 5px;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            & > span {
            font-size: 32px;
            flex-shrink: 0;
            }
            & > div {
            flex: 1;
            //  margin-left: 20px;
            width: 100%;
            overflow: hidden;
            font-size: 14px;
            & > p:first-child {
                margin-left: 20px;
            }
            & > p:last-child {
                margin-top: 3px;
                //  padding-left: 20px;
            }
            }
        }
    }
    .history_but{
        position: absolute;
        bottom: 0px;
        left: 0;
        width: 100%;
        text-align: center;
        font-size: 12px;
        // height: 40px;
        
        
    }
    .history_box{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .back_but{
            text-align: left;
            width: 100%;
          
        }
        .history_list{
            flex: 1;
            min-height: 0;
            padding-right: 5px;
            box-sizing: border-box;
            width: 100%;
            .history_item{
                display: flex;
                margin-top: 10px;
                padding: 8px;
                border-radius: 5px;
                box-sizing: border-box;
                .icon{
                    font-size: 32px;
                    flex-shrink: 0;
                    padding: 0 10px 0 8px;
                }
                .history_item_content{
                    flex: 1;
                    min-width: 0;
                    & > div:first-child {
                        // display: flex;
                        // justify-content: space-between;
                        // align-items: center;
                        margin-bottom: 5px;
                    }
                }
            }
        }
        .notData{
            flex: 1;
            min-height: 0;
            
        }
    }
}
.textAnimate {
    // padding-left: 20px;
    font-size: 12px;
    display: inline-block;
    white-space: nowrap;
    animation: 40s wordsLoop linear infinite normal;
  }

  @keyframes wordsLoop {
    0% {
      transform: translateX(200px);
      -webkit-transform: translateX(200px);
    }
    100% {
      transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
    }
  }

  @-webkit-keyframes wordsLoop {
    0% {
      transform: translateX(200px);
      -webkit-transform: translateX(200px);
    }
    100% {
      transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
    }
  }
</style>